import { FunctionComponent } from 'react';
import './metrics-square.scss';

import { Box, Typography } from '@mui/material';

import { ProgressSpinner } from '@luxon/components';
import { useAppTheme, useScreenSize } from '@luxon/hooks';
import { formatNumber } from '@luxon/formatters';
import { APP_THEME_MODE } from '@luxon/theme';
import { classNames } from '@luxon/utils';

export type TMetricBlockImage = 'truck' | 'car' | 'taxi' | 'motorbike' | 'pedestrian';

interface IMetricsSquareProps {
    value: number;
    description: string;
    imageName?: TMetricBlockImage;
    isLoading?: boolean;
    size?: 'small' | 'normal';
}
const MetricsSquare: FunctionComponent<IMetricsSquareProps> = (props: IMetricsSquareProps) => {
    const { isMobile, isSmallDesktop } = useScreenSize();
    const { themeMode } = useAppTheme();

    const hasImage = props.imageName && !isMobile;

    let imagePath = '';
    if (hasImage) {
        imagePath = `/metric-icons/${props.imageName}.webp`;
    }

    return (
        <Box className={classNames('metrics-square', {
            'has-image': hasImage,
            'dark': themeMode === APP_THEME_MODE.Dark
        })}>
            {
                props.isLoading ? (
                    <ProgressSpinner color='light' size={41} />
                ) : (
                    <Typography
                        variant={isMobile || isSmallDesktop ? 'body3' : props.size === 'small' ? 'h6' : 'h4'}
                        fontWeight={500}
                        color={themeMode === APP_THEME_MODE.Light ? 'light' : undefined}
                        className='no-overflow'
                    >
                        {formatNumber(props.value)}
                    </Typography>
                )
            }

            <Typography
                variant={(hasImage || isMobile || isSmallDesktop) ? 'body3' : 'body2'}
                color={themeMode === APP_THEME_MODE.Light ? 'light' : undefined}
                className='no-overflow'
                display='flex'
                flexDirection='column'
                alignItems='center'
                rowGap='3px'
            >
                {
                    hasImage && (
                        <img src={imagePath} alt={props.imageName} height={isSmallDesktop ? '15px' : '23px'} />
                    )
                }

                {props.description}
            </Typography>
        </Box>
    )
};

export default MetricsSquare;